import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { raiseConfirmation as raiseConfirmationAction } from 'data/messages/messages.actions';

const Success = ({ raiseConfirmation }) => {
  useEffect(() => {
    raiseConfirmation('Password successfully reset. Login using new credentials');
  }, []);

  return <Redirect to="/login" />;
};

Success.propTypes = {
  raiseConfirmation: PropTypes.func.isRequired
};

export default connect(() => ({}), { raiseConfirmation: raiseConfirmationAction })(Success);
